import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  IconButton,
  Grid,
  Typography,
  Chip,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import Tamilfield from "../../../.../../../../../components/tamilfield/index";
import frontpreviewapi from "../../../../../../services/managelicense/index";
import { getDecryptedCookie } from "../../../../../../utils";
import {
  showSnackbar,
} from "../../../../../../redux/snackbar/actions";
import { showLoader, hideLoader } from "../../../../../../redux/loader/actions";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

const useStyles = makeStyles({
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },
  },
  underline: {
    display: "inline-block",
    borderBottom: "2px solid #000",
    paddingBottom: "0.5px !important",
  },
  "@media print": {
    "@page": {
      size: "A4 landscape",
      margin: "0",
    },
    body: {
      margin: "0",
      padding: "0",
    },
    modalContent: {
      backgroundColor: "white",
      borderRadius: "12px",
      boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.2)",
      padding: "15px",
    },
  },
});

const LicensePrintModal = ({
  open,
  onClose,
  textColorStyle,
  businessuuid,
  tempImg,
  firstCanvasRef,
  license,
  secondCanvasRef,
  preview,
  color,
  uploadedImage,
  billpreviewbusinessuuid,
  setBillPreviewBusinessuuid,
  licenseuuid,
  businesssid,
  setLicenseUuid,
  edit,
  index, editableIndex
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { productid, busUid } = useParams();
  const businessid = getDecryptedCookie("bi") || busUid;
  const proid = getDecryptedCookie("proid");
  const language = getDecryptedCookie("lll");
  const [isEditable, setIsEditable] = useState(false);
  const [inputValue, setInputValue] = useState({
    content1:
      language === "en" || language === "enta"
        ? "The amount of every payment Received towards loan"
        : "கடனுக்காக பெறப்பட்ட ஒவ்வொரு கட்டணத்தின் தொகை",
    content2:
      language === "en" || language === "enta"
        ? "I hereby pay the mentioned amount and reclaim the Pledged items from you as detailed here with."
        : "நான் தங்களிடம் அடகு வைத்த பொருட்களை அடகு ரசீது இல்லாமல் பெற்றுக்கொண்டேன் ",
    content3:
      language === "en" || language === "enta"
        ? "I received the goods pledged from them without a Loan receipt."
        : "நான் தங்களிடம் அடகு வைத்த பொருட்களை அடகு ரசீது இல்லாமல் பெற்றுக்கொண்டேன்",
    content4:
      language === "en" || language === "enta"
        ? "Date of redemption or Sale auction Name and address of person redeeming or purchasing at sale in auction."
        : "ஏலத்தில் விற்கப்படும் அல்லது வாங்கும் நபரின் பெயர் மற்றும் முகவரி",
    content5:
      language === "en" || language === "enta"
        ? "The interest rate for the pledged item shall not exceed 12% per annum as simple interest, i.e., one paisa interest for every rupee."
        : "அடகு வைக்கப்பட்ட பொருளுக்கான வட்டி விகிதம் ஆண்டுக்கு 12 சதவீதத்திற்கு மிகாமல் எளிய வட்டியாக. அதாவது ஒவ்வொரு ரூபாய்க்கும் ஒரு பைசா வட்டி.",
    content6:
      language === "en" || language === "enta"
        ? "Every pledged shall be redeemable with in a period of one year or such longer period as may be provided in the contract between the parties from the day of pledging (inclusive of that day) and shall continued to be redeemable during seven days of grace time following the said period"
        : "அடகு வைக்கப்பட்ட நாளிலிருந்து (அந்த நாளையும் சேர்த்து) தரப்பினருக்கு இடையேயான ஒப்பந்தத்தில் வழங்கப்பட்டுள்ளபடி, ஒவ்வொரு அடகும் வைக்கப்பட்டுள்ள ஒரு வருட காலத்திற்குள் அல்லது கூடுதல் காலத்திற்குள் மீட்டெடுக்கப்பட வேண்டும்,",
    content7:
      language === "en" || language === "enta"
        ? "A Pledge shall further continued to be redeemable until it disposed of as provided in the Madras Pawn Broker Act.1943"
        : "மேலும் குறிப்பிட்ட காலத்தை தொடர்ந்து ஏழு நாட்கள் கருணையின் அடிப்படையில் தரப்படும் அதற்குள் மீட்டெடுக்கப்பட வேண்டும். ",
    content8:
      language === "en" || language === "enta"
        ? "Although the period of redemption and days of grace have expired."
        : "1943 ஆம் ஆண்டு மெட்ராஸ் அடகுதாரர்கள் சட்டத்தில் குறிப்பிடப்பட்டுள்ளபடி, மீட்பின் காலம் மற்றும் கருணையின் நாட்கள் கலவாதியாகிவிட்டாலும், அது விற்கப்படும்வரை மீட்டெடுக்கப்படும் உரிமை தொடரும்.",
    content9:
      language === "en" || language === "enta"
        ? "A Pawn Broker may, in addition to the cost of revenue stamp demand take from the pawner a sum not exceeding 25 paisa for any loan not exceeding Rs.250/- and 50 paisa for incidental expenses connected with the advances of such loan"
        : "ஒரு அடகுதாரர், வருவாய் முத்திரையின் விலைக்கு கூடுதலாக, அடகு வைத்திருப்பவரிடமிருந்து ரூ. 250/- க்கு மிகாமல் இருக்கும் எந்த ஒரு கடனிற்கும் 25 பைசாவுக்கு மிகாமல் ஒரு தொகையையும், அத்தகைய கடனுடன் தொடர்புடைய தற்செயலான செலவுகளுக்கு 50 பைசா வரையிலும் வசூலிக்கலாம்.",
    content10:
      language === "en" || language === "enta"
        ? "From 9:00 AM to 1:00 PM and from 3:00 PM to 6:00 PM,with shop holidays on major festivals"
        : "காலை 9.00 மணி முதல் 1.00 மணி வரையிலும் மாலை 3.00 முதல் 6.00 மணி வரையிலும் முக்கிய பண்டிகைகளுக்கு கடை விடுமுறை விடப்படும்.",
    content11:
      language === "en" || language === "enta"
        ? "Interest must be paid once every 3 months. Sunday holiday."
        : "3 மாதத்திற்கு ஒருமுறை வட்டி கட்ட வேண்டும் ஞாயிறு விடுமுறை",
    content12:
      language === "en" || language === "enta"
        ? "Pledged items deposited after 3:00 PM will be returned on next working day."
        : " மாலை 3 மணிக்குமேல் அடமானப்பொருட்களை மீட்கவருபவர்களுக்கு அடுத்தவேளை நாளில் திருப்பித் தரப்படும்.",
    content13:
      language === "en" || language === "enta"
        ? "Keep the receipt safe. If lost, the pawnbroker is not responsible for the pledged item."
        : "ரசீதை பத்திரமாக வைத்து கொள்ள வேண்டும்.",
    content14:
      language === "en" || language === "enta"
        ? "Even if the pledged item is lost or stolen, the pawnbroker has the right to claim only the amount specified on this receipt, and the pawner has no further obligation."
        : "தவறவிட்டால் பொருட்களுக்கு நாங்கள் ஜவாப்தாரியல்ல இந்த ரசீதில் குறிப்பிடப்பட்ட பொருட்கள் எதிர்பாராமல் சேதமடைந்தாலோ திருட்டு போனாலோ ரசீதில் குறிப்பிடப்பட்டிருக்கும் மதிப்புத்தொகையை தவிர மேற்கொண்டு கேட்க அடகு வைத்தவருக்கு உரிமை இல்லை.",
    content15:
      language === "en" || language === "enta"
        ? "For more than one day over the monthly expiration date, the pawner is also entitled to redeem the pledge or pay the interest"
        : "மாதாந்திர கெடுவிற்கு மேல் ஒரு நாள் ஆனாலும் மறுமாத வட்டி வாங்கப்படும் பொருளை வைத்தவர்தான் பொருளை மீட்டுக்கொள்ளவோ வட்டிக்கட்டவோ உரிமையுள்ளவர்.",
    content16:
      language === "en" || language === "enta"
        ? "Sir, as I am unable to come in person, please hand over the pledged item to Mr./Ms"
        : "ஐயா நான் நேரில் வரமுடியாததால் இந்த அடகு ரசீதை கொண்டுவரும் திரு./திருமதி.",
    content17:
      language === "en" || language === "enta"
        ? "upon receiving the principal amount and interest"
        : "வசம் அசல் தொகையும் வட்டியும் பெற்றுக்கொண்டு பொருளை கொடுத்தனுப்பவும்.",
  });

  const handleChange = (e) => {
    setInputValue({ ...inputValue, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    setIsEditable(false);
  };
  const [frontPreview, setFrontPreview] = useState();
  const [busTemplateUuid, setBusTemplateUuid] = useState("");
  const handleSubmit = (formData) => {
    dispatch(showLoader());
    const data = {
      string1: formData?.content1 ? formData.content1 : "",
      string2: formData?.content2 ? formData.content2 : "",
      string3: formData?.content3 ? formData.content3 : "",
      string4: formData?.content4 ? formData.content4 : "",
      string5: formData?.content5 ? formData.content5 : "",
      string6: formData?.content6 ? formData.content6 : "",
      string7: formData?.content7 ? formData.content7 : "",
      string8: formData?.content8 ? formData.content8 : "",
      string9: formData?.content9 ? formData.content9 : "",
      string10: formData?.content10 ? formData.content10 : "",
      string11: formData?.content11 ? formData.content11 : "",
      string12: formData?.content12 ? formData.content12 : "",
      string13: formData?.content13 ? formData.content13 : "",
      string14: formData?.content14 ? formData.content14 : "",
      string15: formData?.content15 ? formData.content15 : "",
      string16: formData?.content16 ? formData.content16 : "",
      string17: formData?.content17 ? formData.content17 : "",
    };
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status) {
        dispatch(
          showSnackbar({
            message: res?.data?.data?.message,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        setIsEditable(false);
        previewfronteditFormik.resetForm();
        billfronteditPreview();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      console.log(err);
      dispatch(
        showSnackbar({
          message: err?.response?.data?.data?.message,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    frontpreviewapi
      .updateFrontPreview(proid, busTemplateUuid, data)
      .then(onSuccess)
      .catch(onFailure);
  };

  const handleEdit = () => {
    setIsEditable(!isEditable);
  };

  const billfronteditPreview = () => {
    const template_name = "loan_print_backside";
    dispatch(showLoader());
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res.data.status) {
        const data = res.data.data.data[0];
        setFrontPreview(data.customization_field);
        setBusTemplateUuid(data.bus_template_uuid);
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      console.error("Failed to fetch saved image", err);
    };

    frontpreviewapi
      .getbillfronteditPreview(
        proid,
        businessid,
        preview?.licId,
        template_name,
        language
      )
      .then(onSuccess)
      .catch(onFailure);
  };

  useEffect(() => {
    if (open) {
      billfronteditPreview();
    }
  }, [open]);

  const previewfronteditFormik = useFormik({
    initialValues: {
      content1: "",
      content2: "",
      content3: "",
      content4: "",
      content5: "",
      content6: "",
      content7: "",
      content8: "",
      content9: "",
      content10: "",
      content11: "",
      content12: "",
      content13: "",
      content14: "",
      content15: "",
      content16: "",
      content17: "",
    },
    validationSchema: Yup.object({
      content1: Yup.string()
        .max(60, "Content  cannot exceed 60 characters"),
      content2: Yup.string()
        .max(150, "Content  cannot exceed 150 characters"),
      content3: Yup.string()
        .max(80, "Content  cannot exceed 80 characters"),
      content4: Yup.string()
        .max(120, "Content  cannot exceed 120 characters"),
      content5: Yup.string()
        .max(140, "Content  cannot exceed 140 characters"),
      content6: Yup.string()
        .max(300, "Content  cannot exceed 300 characters"),
      content7: Yup.string()
        .max(130, "Content  cannot exceed 130 characters"),
      content8: Yup.string()
        .max(200, "Content  cannot exceed 200 characters"),
      content9: Yup.string()
        .max(300, "Content  cannot exceed 300 characters"),
      content10: Yup.string()
        .max(200, "Content  cannot exceed 200 characters"),
      content11: Yup.string()
        .max(65, "Content  cannot exceed 65 characters"),
      content12: Yup.string()
        .max(120, "Content  cannot exceed 120 characters"),
      content13: Yup.string()
        .max(100, "Content  cannot exceed 100 characters"),
      content14: Yup.string()
        .max(250, "Content  cannot exceed 250 characters"),
      content15: Yup.string()
        .max(200, "Content  cannot exceed 200 characters"),
      content16: Yup.string()
        .max(125, "Content  cannot exceed 125 characters"),
      content17: Yup.string()
        .max(100, "Content  cannot exceed 100 characters"),
    }),
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (frontPreview) {
      previewfronteditFormik.setFieldValue("content1", frontPreview?.string1);
      previewfronteditFormik.setFieldValue("content2", frontPreview?.string2);
      previewfronteditFormik.setFieldValue("content3", frontPreview?.string3);
      previewfronteditFormik.setFieldValue("content4", frontPreview?.string4);
      previewfronteditFormik.setFieldValue("content5", frontPreview?.string5);
      previewfronteditFormik.setFieldValue("content6", frontPreview?.string6);
      previewfronteditFormik.setFieldValue("content7", frontPreview?.string7);
      previewfronteditFormik.setFieldValue("content8", frontPreview?.string8);
      previewfronteditFormik.setFieldValue("content9", frontPreview?.string9);
      previewfronteditFormik.setFieldValue("content10", frontPreview?.string10);
      previewfronteditFormik.setFieldValue("content11", frontPreview?.string11);
      previewfronteditFormik.setFieldValue("content12", frontPreview?.string12);
      previewfronteditFormik.setFieldValue("content13", frontPreview?.string13);
      previewfronteditFormik.setFieldValue("content14", frontPreview?.string14);
      previewfronteditFormik.setFieldValue("content15", frontPreview?.string15);
      previewfronteditFormik.setFieldValue("content16", frontPreview?.string16);
      previewfronteditFormik.setFieldValue("content17", frontPreview?.string17);
    }
  }, [frontPreview]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="bill-preview-modal"
      aria-describedby="bill-preview-description"
    >
      <Box
        className={classes.modalContent}
        sx={{
          bgcolor: "white",
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
          outline: "none",
          overflowY: "auto",
          maxHeight: "90vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            position: "absolute",
            top: 15,
            right: 10,
            zIndex: 100,
          }}
        >
          {isEditable && (
           
              <Chip
                label="Update"
                size="small"
                onClick={previewfronteditFormik.handleSubmit}
                variant="contained"
                color="success"
                sx={{
                  color: "white",
                  padding: 1,
                  mr: 1,
                  "&:hover": {
                    backgroundColor: "rgba(255, 0, 0, 0.6)",
                    color: "red.700",
                  },
                  transition: "background-color 0.3s ease",
                }}
              />
           
          )}
          {(edit || editableIndex === index) && (
            <Chip
              label={isEditable ? "Cancel" : "Edit"}
              size="small"
              onClick={handleEdit}
              variant="contained"
              color={isEditable ? "error" : "warning"}
              sx={{
                color: "white",
                padding: 1,
                "&:hover": {
                  backgroundColor: "rgba(255, 0, 0, 0.6)",
                  color: "red.700",
                },
                transition: "background-color 0.3s ease",
              }}
            />
          )}
          <IconButton
            onClick={onClose}
            sx={{
              color: "red.500",
              padding: 1,
              borderRadius: "50%",
              "&:hover": {
                backgroundColor: "rgba(255, 0, 0, 0.6)",
                color: "red.700",
              },
              transition: "background-color 0.3s ease",
            }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box m={1.6}>
          <Box className="print-content">
            <Grid container>
              <Grid
                item
                md={6}
                sx={{
                  pr: "7px",
                  borderRight: {
                    md: `1px dashed ${preview?.billprint || color}`,
                  },
                }}
              >
                <Grid container sx={{ mt: 3 }}>
                  <Grid item md={12}>
                    {isEditable ? (
                      <Tamilfield
                        label="Content"
                        name="content1"
                        id="content1"
                        fullWidth
                        value={previewfronteditFormik.values.content1}
                        onChange={previewfronteditFormik.handleChange}
                        onBlur={previewfronteditFormik.handleBlur}
                        error={
                          previewfronteditFormik.touched.content1 &&
                          Boolean(previewfronteditFormik.errors.content1)
                        }
                        helperText={
                          previewfronteditFormik.touched.content1 &&
                          previewfronteditFormik.errors.content1
                        }
                        setFieldValue={previewfronteditFormik.setFieldValue}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "25px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "12px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "12px",
                          },
                          mb: 1,
                        }}
                      />
                    ) : (
                      <Typography
                        sx={{ textAlign: "center", fontSize: "12px" }}
                        style={{
                          color: preview?.billprint || color,
                        }}
                      >
                        {frontPreview?.string1}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
                <Grid container sx={{ mt: 3 }}>
                  <Grid item md={6}></Grid>
                  <Grid item md={6}>
                    <Typography
                      style={{
                        color: preview?.billprint || color,
                      }}
                      sx={{ fontSize: "12px" }}
                    >
                      {language === "en" || language === "enta"
                        ? "Date:"
                        : "தேதி:"}
                    </Typography>
                  </Grid>
                </Grid>
                <Box mx={5}>
                  <Grid container sx={{ mt: 2 }} spacing={2}>
                    <Grid item md={6}>
                      <Typography
                        style={{
                          color: preview?.billprint || color,
                        }}
                        sx={{ fontSize: "12px" }}
                      >
                        {language === "en" || language === "enta"
                          ? "Amount paid for principal"
                          : "அசலுக்காக செலுத்தியது"}
                      </Typography>
                    </Grid>
                    <Grid item md={6}>
                      <Typography
                        style={{
                          color: preview?.billprint || color,
                        }}
                      >
                        {language === "en" || language === "enta"
                          ? "Rs."
                          : "ரூ."}
                        &nbsp;&nbsp;&nbsp;_____________
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container sx={{ mt: 2 }} spacing={2}>
                    <Grid item md={6}>
                      <Typography
                        style={{
                          color: preview?.billprint || color,
                        }}
                        sx={{ fontSize: "12px" }}
                      >
                        {language === "en" || language === "enta"
                          ? "Amount paid for interest"
                          : "வட்டிக்காக செலுத்தியது"}
                      </Typography>
                    </Grid>
                    <Grid item md={6}>
                      <Typography
                        style={{
                          color: preview?.billprint || color,
                        }}
                      >
                        {language === "en" || language === "enta"
                          ? "Rs."
                          : "ரூ."}
                        &nbsp;&nbsp;&nbsp;_____________
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container sx={{ mt: 2 }} spacing={2}>
                    <Grid item md={6}>
                      <Typography
                        style={{
                          color: preview?.billprint || color,
                        }}
                        sx={{ fontSize: "12px" }}
                      >
                        {language === "en" || language === "enta"
                          ? "Total amount"
                          : "ஆக மொத்தம்"}
                      </Typography>
                    </Grid>
                    <Grid item md={6}>
                      <Typography
                        style={{
                          color: preview?.billprint || color,
                        }}
                      >
                        {language === "en" || language === "enta"
                          ? "Rs."
                          : "ரூ."}
                        &nbsp;&nbsp;&nbsp;_____________
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box mt={2}>
                  <Grid item md={12}>
                    {isEditable ? (
                      <Tamilfield
                        label="Content"
                        name="content2"
                        id="content2"
                        fullWidth
                        value={previewfronteditFormik.values.content2}
                        onChange={previewfronteditFormik.handleChange}
                        onBlur={previewfronteditFormik.handleBlur}
                        error={
                          previewfronteditFormik.touched.content2 &&
                          Boolean(previewfronteditFormik.errors.content2)
                        }
                        helperText={
                          previewfronteditFormik.touched.content2 &&
                          previewfronteditFormik.errors.content2
                        }
                        setFieldValue={previewfronteditFormik.setFieldValue}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "25px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "12px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "12px",
                          },
                          mb: 1,
                        }}
                      />
                    ) : (
                      <Typography
                        sx={{ textAlign: "left", fontSize: "12px" }}
                        style={{
                          color: preview?.billprint || color,
                        }}
                      >
                        {frontPreview?.string2}
                      </Typography>
                    )}
                  </Grid>
                </Box>
                <Box mt={7} mb={3}>
                  <Typography
                    sx={{ textAlign: "center", fontSize: "12px" }}
                    style={{
                      color: preview?.billprint || color,
                    }}
                  >
                    {language === "en" || language === "enta" ? (
                      <p>
                        Signature (or) left thumb impression of the{" "}
                        <b>Pawner</b>
                      </p>
                    ) : (
                      "அடகு வைத்தவரின் கையெழுத்து (அ) இடது கை பெருவிரலின் ரேகை"
                    )}
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Grid item md={12}>
                    {isEditable ? (
                      <Tamilfield
                        label="Content"
                        name="content3"
                        id="content3"
                        fullWidth
                        value={previewfronteditFormik.values.content3}
                        onChange={previewfronteditFormik.handleChange}
                        onBlur={previewfronteditFormik.handleBlur}
                        error={
                          previewfronteditFormik.touched.content3 &&
                          Boolean(previewfronteditFormik.errors.content3)
                        }
                        helperText={
                          previewfronteditFormik.touched.content3 &&
                          previewfronteditFormik.errors.content3
                        }
                        setFieldValue={previewfronteditFormik.setFieldValue}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "25px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "12px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "12px",
                          },
                          mb: 1,
                        }}
                      />
                    ) : (
                      <Typography
                        sx={{ textAlign: "left", fontSize: "12px" }}
                        style={{
                          color: preview?.billprint || color,
                        }}
                      >
                        {frontPreview?.string3}
                      </Typography>
                    )}
                  </Grid>
                </Box>
                <Box mt={7} mb={3}>
                  <Typography
                    sx={{ textAlign: "center", fontSize: "12px" }}
                    style={{
                      color: preview?.billprint || color,
                    }}
                  >
                    {language === "en" || language === "enta" ? (
                      <p>
                        Signature (or) left thumb impression of the{" "}
                        <b>Pawner</b>
                      </p>
                    ) : (
                      "அடகு வைத்தவரின் கையெழுத்து (அ) இடது கை பெருவிரலின் ரேகை"
                    )}
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Grid item md={12}>
                    {isEditable ? (
                      <Tamilfield
                        label="Content"
                        name="content4"
                        id="content4"
                        fullWidth
                        value={previewfronteditFormik.values.content4}
                        onChange={previewfronteditFormik.handleChange}
                        onBlur={previewfronteditFormik.handleBlur}
                        error={
                          previewfronteditFormik.touched.content4 &&
                          Boolean(previewfronteditFormik.errors.content4)
                        }
                        helperText={
                          previewfronteditFormik.touched.content4 &&
                          previewfronteditFormik.errors.content4
                        }
                        setFieldValue={previewfronteditFormik.setFieldValue}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "25px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "12px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "12px",
                          },
                          mb: 1,
                        }}
                      />
                    ) : (
                      <Typography
                        sx={{ textAlign: "left", fontSize: "12px" }}
                        style={{
                          color: preview?.billprint || color,
                        }}
                      >
                        {frontPreview?.string4}
                      </Typography>
                    )}
                  </Grid>
                </Box>
              </Grid>
              <Grid
                item
                md={6}
                sx={{
                  pl: "7px",
                }}
              >
                <Box border={`2px solid ${preview?.billprint || color}`} px={2}>
                  <Grid
                    md={10}
                    mx={"auto"}
                    mt={1}
                    sx={{
                      border: `1px solid ${preview?.billprint || color}`,
                      color: preview?.billprint || color,
                    }}
                  >
                    <Typography
                      style={{
                        color: preview?.billprint || color,
                      }}
                      fontWeight={700}
                      textAlign="center"
                      sx={{ fontSize: "16px" }}
                    >
                      {language === "en" || language === "enta"
                        ? "Terms and Condition"
                        : "விதிமுறைகள் மற்றும் நிபந்தனைகள்"}
                    </Typography>
                  </Grid>
                  <Box mt={2}>
                    {isEditable ? (
                      <Tamilfield
                        label="Content"
                        name="content5"
                        id="content5"
                        fullWidth
                        value={previewfronteditFormik.values.content5}
                        onChange={previewfronteditFormik.handleChange}
                        onBlur={previewfronteditFormik.handleBlur}
                        error={
                          previewfronteditFormik.touched.content5 &&
                          Boolean(previewfronteditFormik.errors.content5)
                        }
                        helperText={
                          previewfronteditFormik.touched.content5 &&
                          previewfronteditFormik.errors.content5
                        }
                        setFieldValue={previewfronteditFormik.setFieldValue}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "25px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "12px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "12px",
                          },
                          mb: 1,
                        }}
                      />
                    ) : (
                      <Typography
                        sx={{ fontSize: "12px" }}
                        style={{
                          color: preview?.billprint || color,
                        }}
                      >
                        {frontPreview?.string5}
                      </Typography>
                    )}
                    {isEditable && (
                      <Tamilfield
                        label="Content"
                        name="content6"
                        id="content6"
                        fullWidth
                        value={previewfronteditFormik.values.content6}
                        onChange={previewfronteditFormik.handleChange}
                        onBlur={previewfronteditFormik.handleBlur}
                        error={
                          previewfronteditFormik.touched.content6 &&
                          Boolean(previewfronteditFormik.errors.content6)
                        }
                        helperText={
                          previewfronteditFormik.touched.content6 &&
                          previewfronteditFormik.errors.content6
                        }
                        setFieldValue={previewfronteditFormik.setFieldValue}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "25px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "12px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "12px",
                          },
                          mb: 1,
                        }}
                      />
                    )}
                    {isEditable && (
                      <Tamilfield
                        label="Content"
                        name="content7"
                        id="content7"
                        fullWidth
                        value={previewfronteditFormik.values.content7}
                        onChange={previewfronteditFormik.handleChange}
                        onBlur={previewfronteditFormik.handleBlur}
                        error={
                          previewfronteditFormik.touched.content7 &&
                          Boolean(previewfronteditFormik.errors.content7)
                        }
                        helperText={
                          previewfronteditFormik.touched.content7 &&
                          previewfronteditFormik.errors.content7
                        }
                        setFieldValue={previewfronteditFormik.setFieldValue}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "25px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "12px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "12px",
                          },
                          mb: 1,
                        }}
                      />
                    )}
                    {isEditable && (
                      <Tamilfield
                        label="Content"
                        name="content8"
                        id="content8"
                        fullWidth
                        value={previewfronteditFormik.values.content8}
                        onChange={previewfronteditFormik.handleChange}
                        onBlur={previewfronteditFormik.handleBlur}
                        error={
                          previewfronteditFormik.touched.content8 &&
                          Boolean(previewfronteditFormik.errors.content8)
                        }
                        helperText={
                          previewfronteditFormik.touched.content8 &&
                          previewfronteditFormik.errors.content8
                        }
                        setFieldValue={previewfronteditFormik.setFieldValue}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "25px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "12px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "12px",
                          },
                          mb: 1,
                        }}
                      />
                    )}
                    {!isEditable && (
                      <Typography
                        style={{
                          color: preview?.billprint || color,
                        }}
                        textAlign="justify"
                        mt={1}
                        fontSize={12}
                      >
                        {frontPreview?.string6}&nbsp;{frontPreview?.string7}
                        &nbsp;
                        {frontPreview?.string8}
                      </Typography>
                    )}
                    <Box mt={2}>
                      {isEditable ? (
                        <Tamilfield
                          label="Content"
                          name="content9"
                          id="content9"
                          fullWidth
                          value={previewfronteditFormik.values.content9}
                          onChange={previewfronteditFormik.handleChange}
                          onBlur={previewfronteditFormik.handleBlur}
                          error={
                            previewfronteditFormik.touched.content9 &&
                            Boolean(previewfronteditFormik.errors.content9)
                          }
                          helperText={
                            previewfronteditFormik.touched.content9 &&
                            previewfronteditFormik.errors.content9
                          }
                          setFieldValue={previewfronteditFormik.setFieldValue}
                          InputLabelProps={{ shrink: true }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "25px",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "12px",
                            },
                            "& .MuiFormLabel-root": {
                              fontSize: "12px",
                            },
                            mb: 1,
                          }}
                        />
                      ) : (
                        <Typography
                          sx={{ fontSize: "12px" }}
                          style={{
                            color: preview?.billprint || color,
                          }}
                        >
                          {frontPreview?.string9}
                        </Typography>
                      )}
                    </Box>
                    <Box mt={2}>
                      {isEditable ? (
                        <Tamilfield
                          label="Content"
                          name="content10"
                          id="content10"
                          fullWidth
                          value={previewfronteditFormik.values.content10}
                          onChange={previewfronteditFormik.handleChange}
                          onBlur={previewfronteditFormik.handleBlur}
                          error={
                            previewfronteditFormik.touched.content10 &&
                            Boolean(previewfronteditFormik.errors.content10)
                          }
                          helperText={
                            previewfronteditFormik.touched.content10 &&
                            previewfronteditFormik.errors.content10
                          }
                          setFieldValue={previewfronteditFormik.setFieldValue}
                          InputLabelProps={{ shrink: true }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "25px",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "12px",
                            },
                            "& .MuiFormLabel-root": {
                              fontSize: "12px",
                            },
                            mb: 1,
                          }}
                        />
                      ) : (
                        <Typography
                          sx={{ fontSize: "12px" }}
                          style={{
                            color: preview?.billprint || color,
                          }}
                        >
                          {language === "en" || language === "enta"
                            ? " Working hours:"
                            : "வேலை நேரம்:"}{" "}
                          {frontPreview?.string10}
                        </Typography>
                      )}
                    </Box>

                    <Grid
                      md={10}
                      p={1}
                      mx={"auto"}
                      mt={2}
                      sx={{
                        border: `1px solid ${preview?.billprint || color}`,
                        color: preview?.billprint || color,
                      }}
                    >
                      {isEditable ? (
                        <Tamilfield
                          label="Content"
                          name="content11"
                          id="content11"
                          fullWidth
                          value={previewfronteditFormik.values.content11}
                          onChange={previewfronteditFormik.handleChange}
                          onBlur={previewfronteditFormik.handleBlur}
                          error={
                            previewfronteditFormik.touched.content11 &&
                            Boolean(previewfronteditFormik.errors.content11)
                          }
                          helperText={
                            previewfronteditFormik.touched.content11 &&
                            previewfronteditFormik.errors.content11
                          }
                          setFieldValue={previewfronteditFormik.setFieldValue}
                          InputLabelProps={{ shrink: true }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "25px",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "12px",
                            },
                            "& .MuiFormLabel-root": {
                              fontSize: "12px",
                            },
                            mb: 1,
                          }}
                        />
                      ) : (
                        <Typography
                          style={{
                            color: preview?.billprint || color,
                          }}
                          fontWeight={700}
                          textAlign="center"
                        >
                          {" "}
                          {frontPreview?.string11}
                        </Typography>
                      )}
                    </Grid>
                    <Box mt={2}>
                      {isEditable && (
                        <Tamilfield
                          label="Content"
                          name="content12"
                          id="content12"
                          fullWidth
                          value={previewfronteditFormik.values.content12}
                          onChange={previewfronteditFormik.handleChange}
                          onBlur={previewfronteditFormik.handleBlur}
                          error={
                            previewfronteditFormik.touched.content12 &&
                            Boolean(previewfronteditFormik.errors.content12)
                          }
                          helperText={
                            previewfronteditFormik.touched.content12 &&
                            previewfronteditFormik.errors.content12
                          }
                          setFieldValue={previewfronteditFormik.setFieldValue}
                          InputLabelProps={{ shrink: true }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "25px",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "12px",
                            },
                            "& .MuiFormLabel-root": {
                              fontSize: "12px",
                            },
                            mb: 1,
                          }}
                        />
                      )}
                      {isEditable && (
                        <Tamilfield
                          label="Content"
                          name="content13"
                          id="content13"
                          fullWidth
                          value={previewfronteditFormik.values.content13}
                          onChange={previewfronteditFormik.handleChange}
                          onBlur={previewfronteditFormik.handleBlur}
                          error={
                            previewfronteditFormik.touched.content13 &&
                            Boolean(previewfronteditFormik.errors.content13)
                          }
                          helperText={
                            previewfronteditFormik.touched.content13 &&
                            previewfronteditFormik.errors.content13
                          }
                          setFieldValue={previewfronteditFormik.setFieldValue}
                          InputLabelProps={{ shrink: true }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "25px",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "12px",
                            },
                            "& .MuiFormLabel-root": {
                              fontSize: "12px",
                            },
                            mb: 1,
                          }}
                        />
                      )}
                      {isEditable && (
                        <Tamilfield
                          label="Content"
                          name="content14"
                          id="content14"
                          fullWidth
                          value={previewfronteditFormik.values.content14}
                          onChange={previewfronteditFormik.handleChange}
                          onBlur={previewfronteditFormik.handleBlur}
                          error={
                            previewfronteditFormik.touched.content14 &&
                            Boolean(previewfronteditFormik.errors.content14)
                          }
                          helperText={
                            previewfronteditFormik.touched.content14 &&
                            previewfronteditFormik.errors.content14
                          }
                          setFieldValue={previewfronteditFormik.setFieldValue}
                          InputLabelProps={{ shrink: true }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "25px",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "12px",
                            },
                            "& .MuiFormLabel-root": {
                              fontSize: "12px",
                            },
                            mb: 1,
                          }}
                        />
                      )}
                      {!isEditable && (
                        <Typography
                          sx={{ fontSize: "12px" }}
                          style={{
                            color: preview?.billprint || color,
                          }}
                        >
                          Note: {frontPreview?.string12}&nbsp;
                          {frontPreview?.string13}&nbsp;{frontPreview?.string14}
                        </Typography>
                      )}
                    </Box>
                    <Box>
                      {isEditable ? (
                        <Tamilfield
                          label="Content"
                          name="content15"
                          id="content1"
                          fullWidth
                          value={previewfronteditFormik.values.content15}
                          onChange={previewfronteditFormik.handleChange}
                          onBlur={previewfronteditFormik.handleBlur}
                          error={
                            previewfronteditFormik.touched.content15 &&
                            Boolean(previewfronteditFormik.errors.content15)
                          }
                          helperText={
                            previewfronteditFormik.touched.content15 &&
                            previewfronteditFormik.errors.content15
                          }
                          setFieldValue={previewfronteditFormik.setFieldValue}
                          InputLabelProps={{ shrink: true }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "25px",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "12px",
                            },
                            "& .MuiFormLabel-root": {
                              fontSize: "12px",
                            },
                            mb: 1,
                          }}
                        />
                      ) : (
                        <Typography
                          sx={{ fontSize: "12px" }}
                          style={{
                            color: preview?.billprint || color,
                          }}
                        >
                          {frontPreview?.string15}
                        </Typography>
                      )}
                    </Box>
                    <Box mt={2}>
                      <Grid container>
                        <Grid item md={11.25}>
                          {isEditable ? (
                            <Tamilfield
                              label="Content"
                              name="content16"
                              id="content16"
                              fullWidth
                              value={previewfronteditFormik.values.content16}
                              onChange={previewfronteditFormik.handleChange}
                              onBlur={previewfronteditFormik.handleBlur}
                              error={
                                previewfronteditFormik.touched.content1 &&
                                Boolean(previewfronteditFormik.errors.content16)
                              }
                              helperText={
                                previewfronteditFormik.touched.content166 &&
                                previewfronteditFormik.errors.content1
                              }
                              setFieldValue={
                                previewfronteditFormik.setFieldValue
                              }
                              InputLabelProps={{ shrink: true }}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "25px",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "12px",
                                },
                                "& .MuiFormLabel-root": {
                                  fontSize: "12px",
                                },
                                mb: 1,
                              }}
                            />
                          ) : (
                            <Typography
                              sx={{ fontSize: "12px" }}
                              style={{
                                color: preview?.billprint || color,
                              }}
                            >
                              {frontPreview?.string16}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item md={0.75}>
                          <Typography
                            style={{
                              color: preview?.billprint || color,
                            }}
                          >
                            ______
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                    <Box>
                      {isEditable ? (
                        <Tamilfield
                          label="Content"
                          name="content17"
                          id="content17"
                          fullWidth
                          value={previewfronteditFormik.values.content17}
                          onChange={previewfronteditFormik.handleChange}
                          onBlur={previewfronteditFormik.handleBlur}
                          error={
                            previewfronteditFormik.touched.content17 &&
                            Boolean(previewfronteditFormik.errors.content17)
                          }
                          helperText={
                            previewfronteditFormik.touched.content17 &&
                            previewfronteditFormik.errors.content17
                          }
                          setFieldValue={previewfronteditFormik.setFieldValue}
                          InputLabelProps={{ shrink: true }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "25px",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "12px",
                            },
                            "& .MuiFormLabel-root": {
                              fontSize: "12px",
                            },
                            mb: 1,
                          }}
                        />
                      ) : (
                        <Typography
                          sx={{ fontSize: "12px" }}
                          style={{
                            color: preview?.billprint || color,
                          }}
                        >
                          {frontPreview?.string17}
                        </Typography>
                      )}
                    </Box>

                    <Grid container spacing={5}>
                      <Grid item md={6} sx={{ visibility: "hidden" }}></Grid>
                      <Grid item md={6} mb={1} mx={"auto"}>
                        <Typography
                          style={{
                            color: preview?.billprint || color,
                          }}
                          mt={5}
                          fontSize={14}
                        >
                          {language === "en"
                            ? "Signature of the redeemer As follows"
                            : "மீட்க வருபவர் கையெழுத்து"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default LicensePrintModal;
